export const PhoneRenderer = (col) => (rowData) => {
    const phone = rowData?.[col.field];
    if (!phone) return "-";

    const number = phone.replace(/\D/g, "");
    return (
        <a href={`https://wa.me/${number}`} target="_blank"
            rel="noopener noreferrer" className="grid-link grid-phone">
            {phone}
        </a>
    );
};